/** Shared display policy; server operations also verify current membership. */
export function canManageLogbook(role: string | null | undefined): boolean {
  return Boolean(role && ['owner', 'admin', 'gm', 'mgr'].includes(role));
}

export function canEditDraft(
  role: string | null | undefined,
  userId: string,
  authorId: string
): boolean {
  return canManageLogbook(role) && userId === authorId;
}
